import translator from '@Components/Utilities/Translator';

const AVPlug = () => {
    return (
		<a class="av-plug" href="https://www.auctionvalues.com?gtmlt=1" target="_blank" aria-label={"View Now (" + translator.translate('sandhills.opensinanewtab') + ")"}>
			<div class="av-bg">
				<div class="av-logo">
					<img src="/Content/images/AVPlug/logo.png" alt="AuctionValues Logo"/>
				</div>
				<div class="av-btn">
					View Now
				</div>
			</div>
			<div class="av-bottom">
				Free Industrywide Auction Results
			</div>
		</a>
    );
}

export default AVPlug